var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"preloader"}},[_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"loader fadeIn"},[_c('img',{staticClass:"image-loader",attrs:{"src":_vm.current_theme == 'light'
            ? require('@/assets/images/icons/fav-dark.png')
            : require('@/assets/images/icons/fav-white.png')}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }